import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { RiEyeFill, RiEyeOffFill } from "react-icons/ri";
import LogoImage from "../../../assets/logo/logo-02.png";
import MonitoredEnvironment from "../../../components/monitoredEnvironment/MonitoredEnvironment";
import { fetchInitialRegister } from "../../../integration/empresas/cadastro/fetchInitialRegister";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Index() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  function handleChangeEmail(event) {
    const emailValue = event.target.value;
    setEmail(emailValue);
  }

  // Função para registrar o usuário
  async function funcRegister() {
    // Expressão regular para validar o formato do e-mail
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    // Verifica se o e-mail é válido
    if (!emailRegex.test(email)) {
      toast.warn("Formato de e-mail inválido", {
        position: toast.POSITION.TOP_RIGHT
      });
      return; // Interrompe a função se o e-mail for inválido
    }

    try {
      const resp = await fetchInitialRegister(email);
      if (resp) {
        toast.success(resp.message, {
          position: toast.POSITION.TOP_RIGHT
        });

        // Redireciona para a página inicial após 5 segundos
        setTimeout(() => {
          navigate("/");
        }, 2000);
      }
    } catch (error) {
      toast.error(error.error, {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  return (
    <>
      {/* Toast Notifications */}
      <ToastContainer />
      <MonitoredEnvironment />

      <div className="flex items-center justify-center   bg-gradient-to-b from-[#f2f2f2] to-[#fbf8f5] bg-cover bg-center">
        <div className="justify-center items-center self-center   h-screen ">
          <div className=" "></div>
          <img
            src={LogoImage}
            alt="Logo"
            className="h-28 w-auto mx-auto mb-5 mt-20"
          />
          <h1 className="text-2xl text-center font-semibold text-gray-700 mb-6">
            Redefinir senha
          </h1>

          <div className="w-96 border-2 none mb-5 rounded-lg border-[#ececec]">
            {/* Requisitos da senha */}
            <p className="text-xs text-gray-500    p-3 text-center">
              Digite o e-mail associado à sua conta e enviaremos um e-mail com
              instruções para redefinir sua senha.
            </p>
          </div>

          <div className="flex   items-center border-2 none border-[#c2c2c2] py-2 px-3 rounded-2xl mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-[#a48f74]"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
              />
            </svg>
            <input
              required
              onChange={handleChangeEmail}
              value={email}
              type="email"
              name="email"
              id="email"
              className="pl-2 bg-transparent  w-full  outline-none border-none text-gray-500   focus:ring-0 focus:border-gray-300"
              placeholder="email"
            />
          </div>

          <button
            type="button"
            onClick={funcRegister}
            className="w-full bg-[#767676] mt-4 py-2 rounded-2xl text-white mb-2 flex items-center justify-center"
          >
            Enviar instruções
          </button>

          <button
            onClick={() => navigate("/")}
            className="w-full text-center text-gray-600 py-2 rounded-2xl border border-gray-200  "
          >
            Voltar
          </button>
        </div>
      </div>
    </>
  );
}
